module.exports = __webpack_public_path__ + "static/media/LeftNav_Icon_Training.b8b6d66d.svg";